import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getSectors } from '../lib/api'
import type { SectorsResp } from '../lib/types'
import RiskDot from '../components/RiskDot'

export default function Sectors() {
  const [data, setData] = useState<SectorsResp | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const load = async () => {
    setLoading(true); setError('')
    try { setData(await getSectors()) } catch (e: any) { setError(e.message) }
    finally { setLoading(false) }
  }
  useEffect(() => { load() }, [])
  if (loading && !data) return <div className="text-muted py-12 text-center">加载中...</div>
  if (error) return <div className="text-red py-12 text-center">错误: {error} <button onClick={load} className="ml-2 text-blue underline">重试</button></div>
  const groups = data?.sectors || []
  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-white text-lg font-semibold">赛道排行 <span className="text-muted text-sm font-normal">· {data?.items.length} 个</span></h2>
        <button onClick={load} disabled={loading} className="text-muted text-sm hover:text-white disabled:opacity-50">
          {loading ? '刷新中...' : '↻ 刷新'}
        </button>
      </div>
      <div className="space-y-6">
        {groups.map(g => (
          <div key={g.name}>
            <div className="flex items-center gap-3 mb-2 text-sm">
              <span className="text-white font-medium">{g.name}</span>
              <span className="text-muted">· {g.count} 个 · 均分 {g.avg_score}</span>
            </div>
            <div className="bg-card border border-border rounded-lg overflow-hidden">
              <table className="w-full text-sm">
                <thead className="bg-bg/50 text-muted text-xs">
                  <tr>
                    <th className="text-left px-3 py-2 font-normal">赛道</th>
                    <th className="text-right px-3 py-2 font-normal">综合分</th>
                    <th className="text-right px-3 py-2 font-normal w-12">风险</th>
                  </tr>
                </thead>
                <tbody>
                  {g.items.map(r => (
                    <tr key={r.id} className="border-t border-border hover:bg-bg/30">
                      <td className="px-3 py-2.5">
                        <Link to={`/sector/${r.id}`} className="text-white hover:text-blue">{r.name}</Link>
                        <div className="text-muted text-xs">{r.ticker} · {r.market}</div>
                      </td>
                      <td className="text-right px-3 py-2.5 text-teal font-semibold">{r.composite_score}</td>
                      <td className="text-right px-3 py-2.5"><RiskDot level={r.risk_level} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
